import { ErrorContainer, LabelComponent, Stack } from 'components';
import { useFormikContext } from 'formik';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { JoyTextArea } from 'modules/notes/joyTextArea';

export const Note = ({ disabled }: { disabled: boolean }) => {
  const { enableMpiUpdate } = useFlags();
  const formik = useFormikContext<{
    note: string;
  }>();

  return (
    <Stack mb={enableMpiUpdate ? '16px' : '0px'} mt="1px">
      {!enableMpiUpdate && <LabelComponent mandatory text="Note" />}
      <JoyTextArea
        value={formik.values.note || ''}
        id="note"
        name="note"
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        placeholder={enableMpiUpdate ? 'Or type here' : 'Type here'}
        rows={10}
        disabled={disabled}
      />
      <ErrorContainer
        visible={formik.touched?.note && formik.errors?.note}
        errors={formik.errors}
        name="note"
      />
    </Stack>
  );
};
